/**
 * src/components/voice/UploadJobTrackerHost.jsx
 *
 * Invisible app-root host for useUploadJobTracker — advances direct-upload job
 * phases tab-independently (the "Processing recording" steps) even after you
 * navigate away. Rehomed here when the two voice-status overlays were
 * consolidated into the single top VoiceQueueTray (CEO 2026-06-21: "one of the
 * two is enough; minimize, not close"). Renders nothing.
 */
import { useUploadJobTracker } from '../../lib/voice/useUploadJobTracker';

export default function UploadJobTrackerHost() {
  useUploadJobTracker();
  return null;
}
